import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, empty } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { IPromoCode } from '../models';
import { BaseResponse } from '../models';
import { ConfigService } from './config.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PromoCodeService {

  constructor(private httpClient: HttpClient) { }

  //#region Promo Code Cache

  private PROMO_CODE: Array<IPromoCode> = [];

  public get promoCodes(): Array<IPromoCode> {
    if (!this.PROMO_CODE) {
      this.PROMO_CODE = [];
    }
    return this.PROMO_CODE;
  }

  public set promoCodes(promoCodes: Array<IPromoCode>) {
    this.PROMO_CODE = promoCodes;
  }

  public updatePromoCodeData(promoCode: IPromoCode): void {
    if (promoCode) {
      const index = this.promoCodes.findIndex(
        r => r.id === promoCode.id
      );

      const existingRecord = this.promoCodes.find(
        r => r.id === promoCode.id
      );

      if (existingRecord) {
        this.PROMO_CODE.splice(index, 1, promoCode);
      } else {
        this.PROMO_CODE.push(promoCode);
      }
    }
  }

  //#endregion

  //#region API Methods

  public getPromoCode(): Observable<Array<IPromoCode>> {
    const endPoint =
      `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_PROMO_CODE}`;

    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => {
          console.log(err);
          console.log(caught);
          return empty();
        }),
        map((response: BaseResponse) => response.data),
        tap((promoCodes: Array<IPromoCode>) => {
          this.promoCodes = promoCodes;
        })
      );
  }

  public savePromoCode(

    data: IPromoCode
  ): Observable<Array<IPromoCode>> {
    const apiEndpoint =
      `${ConfigService.APIs.endPoints.MARKETING_ADMIN.SAVE_PROMO_CODE}`;

    return ApiService.genericObservablePost(
      this.httpClient,
      apiEndpoint,
      data
    ).pipe(
      catchError((err, caught) => {
        console.log(err);
        console.log(caught);
        return empty();
      }),
      map((response: BaseResponse) => response.data),
      tap(() => {
        this.updatePromoCodeData(data);
      })
    );
  }

  public updatePromoCode(body: IPromoCode): Observable<any> {

    const endpoint =
      `${ConfigService.APIs.endPoints.MARKETING_ADMIN.UPDATE_PROMO_CODES}`;

    return ApiService.genericObservablePost(
      this.httpClient,
      endpoint,
      body
    );
  }

  public deletePromoCode(data: IPromoCode): Observable<any> {
    const apiEndpoint =
      `${ConfigService.APIs.endPoints.MARKETING_ADMIN.DELETE_PROMO_CODE}`;

    return ApiService.genericObservablePost(
      this.httpClient,
      apiEndpoint,
      data
    ).pipe(
      catchError((err, caught) => {
        console.log(err);
        console.log(caught);
        return empty();
      }),
      map((response: BaseResponse) => response.data)
    );
  }

  public getAutoGeneratePromoCodes(): Observable<any> {
    const endPoint =
      `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_AUTO_GENERATE_PROMO_CODE}`;

    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => {
          console.log(err);
          console.log(caught);
          return empty();
        }),
        map((response: BaseResponse) => response.data)
      );
  }

  public getFinishes(): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MASTER_DATA.GET_FINISHES}`;

    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => {
          console.log(err);
          console.log(caught);
          return empty();
        }),
        map((response: BaseResponse) => response.data)
      );
  }
  public getRegionCurrencyList(userName: string): Observable<any> {

    const endPoint =
      `${ConfigService.APIs.endPoints.MASTER_DATA.GET_REGION_CURRENCY_LIST}`;

    return ApiService.genericObservablePost(
      this.httpClient,
      endPoint,
      {
        userName: userName
      }
    ).pipe(
      catchError((err, caught) => {
        console.log(err);
        console.log(caught);
        return empty();
      }),
      map((response: BaseResponse) => response.data)
    );
  }

  public getProductDetails(): Observable<any> {
    const body = {
      languageCode: localStorage.getItem('language')
    }
    const endPoint =
      `${ConfigService.APIs.endPoints.MASTER_DATA.GET_PRODUCT_DETAILS}`;

    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => {
          console.log(err);
          console.log(caught);
          return empty();
        }),
        map((response: BaseResponse) => response.data)
      );
  }
  public getPromoCustomerList(): Observable<any> {
    const endPoint =
      `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_PROMO_CUSTOMER_LIST}`;

    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => {
          console.log(err);
          console.log(caught);
          return empty();
        }),
        map((response: BaseResponse) => response.data)
      );
  }
  //#endregion

  

}
